
import TableList from "@components/templates/tablelist";
import { HttpB2BList,HttpPushYuncang,HttpDirectShipment,HttpOrderCancel } from "@/service/boss/b2border";
import { mapState,mapGetters } from "vuex";

import compBesure from './compbesure'
import comIndex from './update/index'
export default {
    mixins: [TableList],
    components: {
        compBesure,
        comIndex,
    },
    data() {
        return {
            // totals: 0,
            isMixin: true,
            Tools: {show: true},
            Tabs: {show: true},
            formData:{
                search:{
                }
            },
            Searchs: {
                show: true,
                labelWidth: 90,
            },
            Plugins: {show: true},
            erpSkusList:[],
            category:'',
            
        };
    },
    methods: {
        ajaxRequest: HttpB2BList,
        interceptRequest(params){
            const search=params.search,createdAt=(search.BT_channelCreated||"").split('~');
            search.GE_channelCreated=createdAt[0];
            search.LE_channelCreated=createdAt[1];
            return params;
        },
        // 全部按钮点击操作
        handleOperates(params="", type,batch) {
            // console.log(batch)
            if(batch){
                params=(params||this.checkedData.join(','))+'';
                if(!params.length) return this.$VMessage.warning(this.$t('global.common.choose_one',{defaultValue:'请选择至少一条数据'}));
            }
            switch (type) {
                case "add":
                    this.$router.push({
                        name: 'b2bOrderupdate',
                        params: { type: "add" },
                    });
                    break;
                case "edit":
                    this.$router.push({
                        name: 'b2bOrderupdate',
                        params: { type: "edit" },
                        query: { id: params},
                    });
                    break;
                case "query":
                    this.operate = {
                        title:this.$t('global.common.operate_see',{defaultValue:'查看'}),
                        show:true,
                        width:1200,
                        component: "comIndex",
                        activeids:params,
                        querytype:'query',
                        showFooter:false,
                    }
                    break;
                case "b2bquery":
                    var url=this.$router.resolve({
                        name: "b2bOrderupdate",
                        params: { type: "query" },
                        query: { id: params },
                    });
                    window.open(url.href, '_blank');
                    break;
                case "invoice":
                    this.operate={
                        show: true,
                        alert: "error",
                        params:{ids:params},
                        title: this.$t('erp.b2border.moreinvoice',{defaultValue:'批量生成发票'}),
                        ajaxRequest:HttpFailureWarehouse
                    }
                    break;
                case "besure":
                    this.operate = {
                        title:this.$t('erp.b2border.confirmorder',{defaultValue:'订单确认'}),
                        show:true,
                        width:600,
                        component: "compBesure",
                        activeids:params,
                        showFooter:false
                    }
                    break;
                case "cancel":
                    this.operate={
                        show: true,
                        alert: "error",
                        params:{orderId:params},
                        title: this.$t('global.common.operatecancel',{defaultValue:'取消操作'}),
                        desc:this.$t('erp.b2border.iscancel',{defaultValue:'确定取消操作'}),
                        ajaxRequest:HttpOrderCancel
                    }
                    break;
                case "directshipment":
                    this.operate={
                        show: true,
                        alert: "error",
                        params:{orderId:params},
                        width:640,
                        title: this.$t('erp.b2border.directship',{defaultValue:'直接发货'}),
                        desc:this.$t('erp.b2border.isdirectship',{defaultValue:'确定直接发货'}),
                        formdata: [
                            {
                                tag: "vTextarea",
                                key: "remark",
                                span: 24,
                                label: this.$t('global.common.notes',{defaultValue:'备注'}),
                                required:false,
                            }
                        ],
                        ajaxRequest:HttpDirectShipment
                    }
                    break;
                case "pushyuncang":
                    this.operate={
                        show: true,
                        alert: "error",
                        params:{orderId:params},
                        title: this.$t('erp.b2c.pushyuncang',{defaultValue:'推送云仓'}),
                        desc:this.$t('erp.b2border.pushyuncang',{defaultValue:'确定推送云仓'}),
                        ajaxRequest:HttpPushYuncang
                    }
                    break;

                
            }
        },
        downloadExcel(){
            this.handleWebfs(process.env.VUE_APP_APIURL_BOSS + "/api/v2/serviceSummary/summaryTemplate", {}, 'download') 
        },
        // 操作下的列表展示内容
        getOperateNodeMap(row){
            const { id, orderStatus } = row
            return [{
                label:this.$t('global.common.operate_see',{defaultValue:'查看'}),
                show:true,
                params:id,
                operate:'query',
            },{
                label:this.$t('global.common.operate_edit',{defaultValue:'编辑'}),
                show:orderStatus == 'pending',
                to: {
                    name: 'b2bOrderupdate',
                    params: { type: 'edit' },
                    query: { id },
                },
            },{
                label:this.$t('global.datepicker.confirm',{defaultValue:'确认'}),
                show:orderStatus == 'pending',
                params:id,
                operate:'besure'
            },{
                label:this.$t('global.common.operate_cancel',{defaultValue:'取消'}),
                show:orderStatus == 'pending' || orderStatus == 'assigned',
                params:id,
                operate:'cancel'
            },{
                label:this.$t('erp.b2border.directship',{defaultValue:'直接发货'}),
                show:orderStatus == 'assigned',
                params:id,
                operate:'directshipment'
            },{
                label:this.$t('erp.b2c.pushyuncang',{defaultValue:'推送云仓'}),
                show:orderStatus == 'assigned',
                params:id,
                operate:'pushyuncang'
            }]
        },
        dedupe(array) {
			var temp = []; //一个新的临时数组
			for(var i = 0; i < array.length; i++){
				if(temp.indexOf(array[i]) == -1){
					temp.push(array[i]);
				}
			}
			return temp;
		},
    },
    computed: {
        ...mapGetters('diction',['getAllSalesList','getAllCustomerList','getNewWarehouseIdList','getNewProductList']),
        // table中单据状态的按钮展示
        orderStatus(){
            return [
                {
                    value: '0',
                    label: this.$t('global.common.effective',{defaultValue:'有效'}),
                    theme:'info',
                },
                {
                    value: '1',
                    label: this.$t('global.common.failure',{defaultValue:'失效'}),
                    theme:'error',
                }, 
            ];
        },
        // 左边的批量操作按钮
        ToolsData(){
            return [
                {
                    name: this.$t('global.common.operate_add',{defaultValue:'添加'}),
                    operate: "add",
                    theme: "primary",
                },
                // {
                //     name: this.$t('erp.b2border.moreinvoice',{defaultValue:'批量生成发票'}),
                //     operate: "invoice",
                // },
            ]
        },
        // 搜索下拉框展示内容
        SearchsData() {
            const dropStyle="width:auto;";
            return  [
                {
                    label: this.$t('global.common.line',{defaultValue:'项目'}),
                    tag: 'vSelect',
                    key: 'EQ_lineId',
                    show:true,
                    options: this.getNewProductList,
                    props:{
                        dropStyle,
                        filterable:true,
                    }
                },
                {
                    label: this.$t('erp.b2c.search_ordernumber',{defaultValue:'订单号'}),
                    tag: 'vInput',
                    key: 'EQ_orderNo',
                    show:true,
                },
                {
                    label: this.$t('erp.b2c.search_orderstatus',{defaultValue:'订单状态'}),
                    tag: 'Select',
                    key: 'IN_orderStatus',
                    show:true,
                    options: [
                        {
                            value: 'pending',
                            label: this.$t('fbb.inbound.draft',{defaultValue:'草稿'})
                        },
                        {
                            value: 'assigned',
                            label: this.$t('global.common.confirmed',{defaultValue:'已确认'})
                        },
                        {
                            value: 'picked',
                            label: this.$t('erp.b2c.orderstatus_picked',{defaultValue:'已配货'})
                        },
                        {
                            value: 'shipped',
                            label: this.$t('erp.b2c.orderstatus_shipped',{defaultValue:'已发货'})
                        },
                        {
                            value: 'completed',
                            label: this.$t('global.upload.complete',{defaultValue:'已完成'})
                        },
                        {
                            value: 'canceled',
                            label: this.$t('erp.b2c.orderstatus_canceled',{defaultValue:'已取消'})
                        },
                    ],
                    props:{
                        dropStyle,
                        filterable:true,
                    }
                },
                {
                    label: this.$t('erp.b2border.refNo',{defaultValue:'参考号'}),
                    tag:'vInput',
                    key: 'EQ_referenceNo',
                },
                {
                    label: this.$t('erp.b2border.invoice',{defaultValue:'发票号'}),
                    tag:'vInput',
                    key: 'EQ_invoiceNo',
                },
                {
                    label: this.$t('global.common.deliveryWarehouse',{defaultValue:'发货仓库'}),
                    tag: 'vSelect',
                    key: 'EQ_orgWarehouseId',
                    options:this.getNewWarehouseIdList,
                    props:{
                        dropStyle,
                        filterable:true,
                    }
                },
                {
                    label: this.$t('erp.b2border.paymentType',{defaultValue:'付款类型'}),
                    tag: 'Select',
                    key: 'EQ_paymentMethod',
                    options: [
                        {
                            value: 10,
                            label: this.$t('erp.b2border.check',{defaultValue:'支票'})
                        },
                        {
                            value: 20,
                            label: this.$t('erp.b2border.remittance',{defaultValue:'汇款'})
                        },
                    ],
                    props:{
                        dropStyle,
                        filterable:true,
                    }
                },
                {
                    label: "ERPSKU",
                    tag: 'vInput',
                    key: 'EQ_saleOrderItemsList.erpSku',
                },
                {
                    label: "Tracking",
                    tag: 'vInput',
                    key: 'EQ_saleOrderItemsList.trackNo',
                },
                {
                    label: this.$t('erp.b2border.customerName',{defaultValue:'客户姓名'}),
                    tag: 'vSelect',
                    key: 'IN_customerId',
                    options:this.getAllCustomerList
                },
                {
                    label: this.$t('erp.b2border.salesman',{defaultValue:'销售员'}),
                    tag: 'vSelect',
                    key: 'IN_salespersonId',
                    options:this.getAllSalesList
                },
                
                // {
                //     label: "订单金额",
                //     tag: 'vInput',
                //     key: 'EQ_price',
                // },
                {
                    label: this.$t('global.common.createdtime',{defaultValue:'创建时间'}),
                    tag: 'vDatepicker',
                    key: 'BT_channelCreated',
                    props:{
                        format:'yyyy-mm-dd ~ yyyy-mm-dd',
                        confirm:false,
                    },
                },
                
            ]
        },
        // table的展示数据
        columns() {
            return  [{
                type: 'selection',
                width: 40,
                align: 'center',
                formName: 'id'
            },{
                title: this.$t('global.common.operation',{defaultValue:'操作'}),
                width: 90,
                render:this.getOperateNodes
            }, 
            {
                title: this.$t('erp.b2c.search_ordernumber',{defaultValue:'订单号'}),
                sortable: true,
                render:(h,{row})=>{
                    return <div>
                        <div>
                            <a onClick={this.handleOperates.bind(this, row.id, 'query')}>{row.id}</a>
                            <a onClick={this.handleOperates.bind(this, row.id, 'b2bquery')}><Icon class="margin-left-10 font-14" type="ios-browsers-outline" /></a>
                        </div>
                        <div>
                            {row.orderNo}
                        </div>
                        
                    </div>
                }
            },
            {
                title: this.$t('erp.b2c.search_orderstatus',{defaultValue:'订单状态'}),
                width:100,
                sortable: true,
                render:(h,{row})=>{
                    let status;
                    switch(row.orderStatus){
                        case 'pending': return <vButton class="b2cspan-error span-padding">{this.$t('fbb.inbound.draft',{defaultValue:'草稿'})}</vButton>;break;
                        case 'assigned': return <vButton class="b2cspan-success span-padding">{this.$t('global.common.confirmed',{defaultValue:'已确认'})}</vButton>;break;
                        case 'picked': return <vButton class="b2cspan-info span-padding">{this.$t('erp.b2c.orderstatus_picked',{defaultValue:'已配货'})}</vButton>;break;
                        case 'shipped': return <vButton class="b2cspan-light-content span-padding">{this.$t('erp.b2c.orderstatus_shipped',{defaultValue:'已发货'})}</vButton>;break;
                        case 'canceled': return <vButton class="b2cspan-warning span-padding">{this.$t('erp.b2c.orderstatus_canceled',{defaultValue:'已取消'})}</vButton>;break;
                        case 'completed': return <vButton class="b2cspan-dark-primary span-padding">{this.$t('global.upload.complete',{defaultValue:'已完成'})}</vButton>;break;
                    }
                }
            },
            
            {
                title: this.$t('erp.b2border.line_refno',{defaultValue:'项目/参考号'}),
                // key: 'lineId',
                sortable: true,
                render:(h, { row })=>{
                    const id = row.lineId;
                    const product = this.getNewProductList.filter((item) => {
                        return id == item.value
                    })[0] || {};
                    return <div>
                        <div>{product.label}</div>
                        <div>{row.saleOrderDetails.referenceNo || '--'}</div>
                    </div>
                }
            },
            {
                title: this.$t('global.common.warehouse',{defaultValue:'仓库'}),
                render:(h,{row})=>{
                    const wareitem = this.getNewWarehouseIdList.filter((item) => {
                        // console.log(item.value)
                        return row.orgWarehouseId === item.value
                    })[0] || {};
                    return <div>
                        <div>{wareitem.label})</div>
                    </div>
                },
                sortable: true
            },
            {
                title: this.$t('erp.b2border.salesman',{defaultValue:'销售员'}),
                render:(h,{row})=>{
                    const saleid = row.salespersonId;
                    const saleitem = this.getAllSalesList.filter((item) => {
                        // console.log(item.value)
                        return saleid === item.value
                    })[0] || {};
                    return <div>{saleitem.label}</div>
                }
            },
            {
                title: this.$t('erp.b2border.paymentType_invoice',{defaultValue:'付款类型/发票号'}),
                render:(h,{row})=>{
                    return <div>
                    <div>{row.paymentMethod == 10 ? this.$t('erp.b2border.check',{defaultValue:'支票'}) : this.$t('erp.b2border.remittance',{defaultValue:'汇款'})}</div>
                    <div>{row.saleOrderDetails.invoiceNo || '--'}</div>
                    </div>
                }
            },
            {
                title: this.$t('global.common.created_updated',{defaultValue:'创建/更新时间'}),
                render:(h,{row})=>{
                    let a = row.channelCreated.replace("T"," ")
                    let channelCreated = a.replace("+00:00","")
                    return <div>
                    <div>{channelCreated}</div>
                    <div>{row.updatedAt}</div>
                    </div>
                }
            },
        ];
        },
        
    },
};
